import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import ReactDOM from "react-dom/client";
import "virtual:uno.css";
import App from "./App.tsx";
import ErrorBoundary from "./client/components/ErrorBoundary.tsx";
import { AppConfigProvider } from "./context/AppConfigProviderContext.tsx";
import { dynamicActivate } from "./i18n.ts";

const root = document.querySelector("#mobility-trade-org-layout-root");

async function hydrate() {
  const encodedProps = root?.getAttribute("data-props");
  const props = encodedProps ? JSON.parse(decodeURIComponent(atob(encodedProps))) : undefined;

  if (encodedProps && root) {
    root.removeAttribute("data-props");
  }

  if (!root || !props || Object.keys(props).length === 0) {
    return;
  }

  const { appConfig } = props;
  await dynamicActivate(appConfig.locale);

  ReactDOM.hydrateRoot(
    root,
    <I18nProvider i18n={i18n}>
      <AppConfigProvider appConfig={appConfig}>
        <ErrorBoundary helpCenter={appConfig.helpCenter}>
          <App />
        </ErrorBoundary>
      </AppConfigProvider>
    </I18nProvider>,
  );
}

hydrate();
